import React from "react";

interface PoweredByProps {
  className?: string;
}

export const PoweredBySnpQuartr: React.FC<PoweredByProps> = ({
  className = "",
}) => {
  return (
    <div className={`text-center ${className}`}>
      <div className="flex items-center justify-center gap-4">
        <img
          src="/images/S&P_Global_logo.svg.png"
          alt="S&P Cap IQ"
          className="h-4 opacity-80"
        />
        <img
          src="/images/quartrLogo.svg"
          alt="Quartr"
          className="h-8 opacity-80"
        />
      </div>
    </div>
  );
};
